// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604292255/js/" + chunkId + "." + {"44":"88899b5b","225":"b4f17e7d","481":"456213ee","486":"41257c51","770":"d1a2fec9"}[chunkId] + ".0.5777830241652828.chunk.js";
};